import React from "react";

const HumiditySvg = () => {
	return (
		<svg
			width="34"
			height="39"
			viewBox="0 0 34 39"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Humidity</title>
			<path
				d="M17 39C12.4973 39 8.66339 37.4451 5.49825 34.3352C2.33275 31.2253 0.75 27.4394 0.75 22.9775C0.75 20.848 1.1716 18.8112 2.01479 16.867C2.85763 14.9224 4.02221 13.1974 5.50854 11.6919L17 0.416565L28.4915 11.6919C29.9778 13.1974 31.1424 14.9226 31.9852 16.8675C32.8284 18.8125 33.25 20.8506 33.25 22.9819C33.25 27.4466 31.6673 31.2325 28.5018 34.3395C25.3366 37.4465 21.5027 39 17 39ZM4 22.9873H30C30 21.2901 29.675 19.6715 29.025 18.1318C28.375 16.5924 27.4361 15.2429 26.2083 14.0834L17 4.98336L7.79167 14.0834C6.56389 15.2429 5.625 16.5924 4.975 18.1318C4.325 19.6715 4 21.2901 4 22.9873Z"
				fill="#5663F2"
			/>
		</svg>
	);
};

export default HumiditySvg;
